// src/pages/adminDashboard/index.js
import React, { useEffect, useState } from "react";
import { Card, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchInstitutions } from "./AdminDashboardThunk";
import CompanyTable from "./components/CompanyTable";
import CompanyForm from "./components/CompanyForm";
import AdminDashboardFilters from "./components/AdminDashboardFilters";
import "./index.css";

const AdminDashboard = ({authInfo}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);

  useEffect(() => { dispatch(fetchInstitutions()); }, [dispatch]);

  return (
    <div className="p-2 p-md-4">
      <AdminDashboardFilters />
      <Card
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
              onClick={() => navigate(-1)}
              style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
              data-testid="admin-dashboard-back-button"
            />
            Admin Dashboard
          </div>
        }
        className="admin-dashboard-card"
        extra={!showForm && <Button type="primary" onClick={() => setShowForm(true)}  data-testid="add-company-button">Add Company</Button>}
      >
        {showForm
          ? <CompanyForm authInfo={authInfo} onClose={() => setShowForm(false)} />
          : <CompanyTable onEdit={() => setShowForm(true)} />}
      </Card>
    </div>
  );
};

export default AdminDashboard;
